<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor } from '@/utils/modules/getStyles'
import { filtersRichtext, textLenHandler } from '@/utils/common'

export default {
  name: 'Comp45',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: {
    getShadowColor, filtersRichtext, textLenHandler,
    onModuleItem(v) {
      this.$emit('onModuleItem', v)
    }
  }
}
</script>

<template>
  <div class="modules-id-45">
    <module-title :title="moduleOption.title" margin-bottom="14" />
    <div class="comp-transverse-2 modules-id-45-content">
      <div
        v-for="(v, i) in moduleOption.list.slice(0, 6)"
        :key="`modules-id-45-item-${i}`"
        class="item"
        @click="onModuleItem(v)"
      >
        <div class="memo-box">
          <p class="item-headline h-line-1">{{ v.headline }}</p>
          <p class="item-memo h-line-2">{{ filtersRichtext(v.memo) }}</p>
        </div>
        <el-image class="item-img" :src="v.photo | imgPath" alt="img" fit="cover" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-45-content {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  column-gap: 50px;
  row-gap: 20px;
  .item {
    width: 311px;
    height: 90px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    background: url('~imgs/modules/comp44t2-bg.png') no-repeat center;
    background-size: 100% 100%;
    position: relative;
    .item-img {
      width: 90px;
      height: 56px;
      border-radius: 5px;
      position: absolute;
      left: -14px;
    }
  }
  .memo-box {
    width: 300px;
    height: 80px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding: 10px 20px;
    box-sizing: border-box;
    .item-headline {
      width: 190px;
      font-size: 15px;
      font-weight: bold;
      color: #228E76;
      font-family: siyuansong;
      margin-left: 10px;
    }
    .item-memo {
      width: 190px;
      // height: 50px;
      font-size: 13px;
      font-weight: bold;
      color: #268877;
    }
  }
}
</style>
